import styled from "styled-components";
import { theme, typography } from "../styles";

export const FeaturesSection = styled.section`
  position: relative;
  padding: 64px 16px;
  background: ${theme.secondarySoft};

  @media (min-width: 768px) {
    padding: 96px 24px;
  }
`;

export const FeaturesInner = styled.div`
  width: 100%;
  max-width: 1152px;
  margin: 0 auto;
`;

export const FeaturesHeader = styled.div`
  max-width: 672px;
  margin: 0 auto 40px;
  text-align: center;

  @media (min-width: 768px) {
    margin-bottom: 64px;
  }
`;

export const FeaturesTitle = styled.h2`
  margin: 0 0 16px;
  color: ${theme.foreground};
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: ${typography.weights.extrabold};
  line-height: 1.15;

  span {
    background-image: ${theme.gradientGold};
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }
`;

export const FeaturesLead = styled.p`
  margin: 0;
  color: ${theme.textMuted};
  font-size: clamp(1.0625rem, 2vw, 1.25rem);
  line-height: 1.55;
`;

export const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;
  max-width: 1152px;
  margin: 0 auto;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

export const FeatureCard = styled.article`
  padding: 24px;
  border: 1px solid ${theme.border};
  border-radius: 16px;
  background: ${theme.card};
  transition: border-color 0.3s ease;

  &:hover {
    border-color: hsl(32 95% 55% / 0.3);
  }

  @media (min-width: 768px) {
    padding: 32px;
  }
`;

export const FeatureIconWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin-bottom: 24px;
  border-radius: ${theme.radius};
  background: hsl(32 95% 55% / 0.1);
  color: ${theme.primary};
  transition: background 0.3s ease;

  ${FeatureCard}:hover & {
    background: hsl(32 95% 55% / 0.2);
  }

  .material-icons {
    font-size: 28px;
  }
`;

export const FeatureTitle = styled.h3`
  margin: 0 0 12px;
  color: ${theme.foreground};
  font-size: 1.25rem;
  font-weight: ${typography.weights.bold};
`;

export const FeatureText = styled.p`
  margin: 0;
  color: ${theme.textMuted};
  font-size: 1rem;
  line-height: 1.65;
`;
